import { render } from "./ModelView.vue?vue&type=template&id=4e530cf0&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"

import "./ModelView.vue?vue&type=style&index=0&id=4e530cf0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e530cf0"]])

export default __exports__